import { render, staticRenderFns } from "./c_tab_input.vue?vue&type=template&id=0405ea7b&scoped=true"
import script from "./c_tab_input.vue?vue&type=script&lang=js"
export * from "./c_tab_input.vue?vue&type=script&lang=js"
import style0 from "./c_tab_input.vue?vue&type=style&index=0&id=0405ea7b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0405ea7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0405ea7b')) {
      api.createRecord('0405ea7b', component.options)
    } else {
      api.reload('0405ea7b', component.options)
    }
    module.hot.accept("./c_tab_input.vue?vue&type=template&id=0405ea7b&scoped=true", function () {
      api.rerender('0405ea7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_tab_input.vue"
export default component.exports